var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-view"},[_c('div',{staticClass:"main-view__container is-block",style:(_vm.backgroundImageUrl ? ("background-image: url(" + _vm.backgroundImageUrl + ")") : '')},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }